/**
 * Calendar query keys.
 *
 * The grid's key carries the WINDOW, so scrolling to next week is a new cache
 * entry rather than a refetch that blanks the current one, and stepping back is
 * instant. Every write invalidates `all`, because a single edit can move a
 * meeting out of one window and into another and only the server knows which.
 */

export const CALENDAR_KEYS = {
  all: ['calendar'] as const,
  window: (from: string, to: string) => [...CALENDAR_KEYS.all, 'window', from, to] as const,
  meeting: (meetingId: string) => [...CALENDAR_KEYS.all, 'meeting', meetingId] as const,
  invitees: (meetingId: string) => [...CALENDAR_KEYS.all, 'invitees', meetingId] as const,
  /**
   * The dates of a series INSIDE a window. The window is part of the key for
   * the reason it is part of the grid's: next week is a different answer, not a
   * refetch of this one. With no window it is "what is still to come".
   */
  occurrences: (meetingId: string, from?: string, to?: string) =>
    [...CALENDAR_KEYS.all, 'occurrences', meetingId, from ?? 'upcoming', to ?? ''] as const,
  people: (query: string) => [...CALENDAR_KEYS.all, 'people', query] as const,
  /** A join code resolved without joining — the pre-join screen's read. */
  byCode: (joinCode: string) => [...CALENDAR_KEYS.all, 'by-code', joinCode] as const,
  /** The groups and teams an organiser can invite as a unit. */
  audiences: () => [...CALENDAR_KEYS.all, 'audiences'] as const,
} as const;
